<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_handoff.svg`)"
            imageLabel="Handoff Method"
            heading="Where can renters pick-up & drop-off?"
            :step="6"
        >
        
            <div class="ph3 ph4-ns">
                <!-- address inputs -->
                <AddressSelection :location="location"/>
            </div>
        </ListContainer>

        <!-- navigation buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" :enabledForward="isEnabled" forward="Next" @backClick="$router.push('/owner-delivery')" @forwardClick="$router.push('/rates')" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import FullAddressInput from '@/components/global/FullAddressInput.vue';
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import AddressSelection from '@/components/global/AddressSelection.vue';

export default {
    data() {
        return {
            location: {
                address: '',
                postalCode: '',
                city: '',
                province: ''
            }
        };
    },
    components: {
        ShadowBoxContainer,
        ListContainer,
        FullAddressInput,
        NavigationButtons,
        AddressSelection
    },
    computed: {
        isEnabled() {
            var enabled = true;

            for (var property in this.location) {
                if (this.location[property] === '') {
                    enabled = false;
                }
            }

            return enabled;
        }
    }
};
</script>
